import { useContext } from 'react';

import { WizardContext } from './WizardContext';

export const useWizardContext = () => useContext(WizardContext);
